<h1 mat-dialog-title>{{ data?.item ? 'Bijzonderheid bewerken' : `Nieuwe bijzonderheid` }}</h1>
@if (!loading()) {
  <mat-dialog-content>
    <p>Upload een icoon voor de bijzonderheid in .svg formaat</p>
    <form (ngSubmit)="save()" [formGroup]="form">
      <div class="svg-preview">
        <div
          class="icon-wrapper"
          [matTooltip]="previewIconId() ? 'Ongeselecteerde weergave.' : ''"
          [matTooltipClass]="previewIconId() ? 'preview-tooltip' : ''"
        >
          @if (previewIconId()) {
            <div class="icon">
              <mat-icon [svgIcon]="previewIconId()"></mat-icon>
            </div>
          }
        </div>
        <div
          class="icon-wrapper"
          [matTooltip]="previewIconId() ? 'Geselecteerde weergave.' : ''"
          [matTooltipClass]="previewIconId() ? 'preview-tooltip' : ''"
        >
          @if (previewIconId()) {
            <div class="icon active">
              <mat-icon [svgIcon]="previewIconId()"></mat-icon>
            </div>
          }
        </div>
        @if (!data.isSystemParticularity) {
          <div class="svg-buttons">
            <button type="button" mat-stroked-button class="upload-button" (click)="fileInput.click()">
              <mat-icon>upload</mat-icon>Upload
            </button>
            <button
              type="button"
              mat-stroked-button
              class="download-button"
              (click)="downloadSvg()"
              [disabled]="!previewIconId()"
            >
              <mat-icon>download</mat-icon>Download
            </button>
            <input hidden (change)="onFileSelected($event)" #fileInput type="file" accept=".svg" />
          </div>
        }
      </div>
      @if (svgError()) {
        <mat-error class="svg-error">{{ svgError() }}</mat-error>
      }
      <mat-form-field>
        <mat-label>Naam</mat-label>
        <input placeholder="Naam" formControlName="name" autocomplete="off" type="text" matInput />
        <mat-error>{{ getError('name') }}</mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Beschrijving</mat-label>
        <input placeholder="Beschrijving" formControlName="description" autocomplete="off" type="text" matInput />
        <mat-hint>{{ form.get('description').value?.length || 0 }}/40</mat-hint>
        <mat-error>{{ getError('description') }}</mat-error>
      </mat-form-field>

      <mat-slide-toggle formControlName="takesSeat">Neemt een extra zitplaats in gebruik</mat-slide-toggle>
      <mat-slide-toggle formControlName="active">Actief</mat-slide-toggle>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button type="button" mat-dialog-close>Annuleren</button>
    <button
      mat-flat-button
      type="submit"
      (click)="save()"
      [class.spinner]="saving()"
      [disabled]="form.invalid || !previewIconId() || saving()"
    >
      Opslaan
    </button>
  </mat-dialog-actions>
}
